import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import { Box } from '@mui/material';
/**
 * Cloudflare Turnstile site key. Human verification is only active when a key is configured,
 * so environments without a key (e.g. local dev before provisioning) degrade gracefully to no captcha.
 */

import { jsx as _jsx } from "react/jsx-runtime";
var TURNSTILE_SITE_KEY = process.env['NX_TURNSTILE_SITE_KEY'] || '';
export var isTurnstileCaptchaEnabled = function isTurnstileCaptchaEnabled() {
  return Boolean(TURNSTILE_SITE_KEY);
};

/**
 * Reusable human-verification widget (Cloudflare Turnstile) for auth flows.
 * Renders nothing when no site key is configured — pair with isTurnstileCaptchaEnabled()
 * in the host form so submission is only gated when the captcha is active.
 */
export var TurnstileCaptcha = /*#__PURE__*/forwardRef(function (props, ref) {
  var onVerify = props.onVerify;
  var widgetRef = useRef(undefined);
  /**
   * methods
   */

  var verifySuccessAction = function verifySuccessAction(token) {
    onVerify(token);
  };

  var verifyInvalidAction = function verifyInvalidAction() {
    onVerify(null);
  };
  /**
   * external methods
   */


  useImperativeHandle(ref, function () {
    return {
      reset: function reset() {
        var _widgetRef$current;

        (_widgetRef$current = widgetRef.current) === null || _widgetRef$current === void 0 ? void 0 : _widgetRef$current.reset();
        onVerify(null);
      }
    };
  });

  if (!isTurnstileCaptchaEnabled()) {
    return null;
  } // min-height matches the widget height to avoid layout shift while the challenge script loads


  return /*#__PURE__*/_jsx(Box, {
    className: "flex min-h-[65px] w-full justify-center",
    children: /*#__PURE__*/_jsx(Turnstile, {
      ref: widgetRef,
      siteKey: TURNSTILE_SITE_KEY,
      options: {
        theme: 'light',
        size: 'flexible'
      },
      onSuccess: verifySuccessAction,
      onExpire: verifyInvalidAction,
      onError: verifyInvalidAction,
      onTimeout: verifyInvalidAction
    })
  });
});
TurnstileCaptcha.displayName = 'TurnstileCaptcha';
export default TurnstileCaptcha;